function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "COM-4258",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "account_circle_black"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 32 0 32 32 0 32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,2.66666667 C8.64,2.66666667 2.66666667,8.64 2.66666667,16 C2.66666667,23.36 8.64,29.3333333 16,29.3333333 C23.36,29.3333333 29.3333333,23.36 29.3333333,16 C29.3333333,8.64 23.36,2.66666667 16,2.66666667 Z M9.42666667,24.3733333 C10,23.1733333 13.4933333,22 16,22 C18.5066667,22 22.0133333,23.1733333 22.5733333,24.3733333 C20.76,25.8133333 18.48,26.6666667 16,26.6666667 C13.52,26.6666667 11.24,25.8133333 9.42666667,24.3733333 Z M24.48,22.44 C22.5733333,20.12 17.9466667,19.3333333 16,19.3333333 C14.0533333,19.3333333 9.42666667,20.12 7.52,22.44 C6.16,20.6533333 5.33333333,18.4266667 5.33333333,16 C5.33333333,10.12 10.12,5.33333333 16,5.33333333 C21.88,5.33333333 26.6666667,10.12 26.6666667,16 C26.6666667,18.4266667 25.84,20.6533333 24.48,22.44 L24.48,22.44 Z M16,8 C13.4133333,8 11.3333333,10.08 11.3333333,12.6666667 C11.3333333,15.2533333 13.4133333,17.3333333 16,17.3333333 C18.5866667,17.3333333 20.6666667,15.2533333 20.6666667,12.6666667 C20.6666667,10.08 18.5866667,8 16,8 Z M16,14.6666667 C14.8933333,14.6666667 14,13.7733333 14,12.6666667 C14,11.56 14.8933333,10.6666667 16,10.6666667 C17.1066667,10.6666667 18,11.56 18,12.6666667 C18,13.7733333 17.1066667,14.6666667 16,14.6666667 Z",
  id: "Shape",
  fill: "#001A70",
  fillRule: "nonzero"
})));

function SvgAccountCircleBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account_circle_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleBlack);
export default __webpack_public_path__ + "static/media/account_circle_black.a1f8886c.svg";
export { ForwardRef as ReactComponent };